
export default {
  props: ["item"],
  data(){
    return{
      show:false
    }
  },
  mounted() {
    if (
      this.$hyperItem.categoryCheck(this.item) && this.item.prices.profit >= this.item.profit_threshold
    ) {
      this.show = true;
    }
  },
};
